import React from 'react'
import {BsPersonBoundingBox} from 'react-icons/bs'
import {RiAB} from 'react-icons/ri'
import CourseClassAttendanceTab from './tabs/CourseClassAttendanceTab'
import CourseClassGradeTab from './tabs/CourseClassGradeTab'
import CourseClassInformationTab from './tabs/CourseClassInforTab'
import CourseClassNewsTab from './tabs/CourseClassNewsTab'
import CourseClassSubjectTab from './tabs/CourseClassSubjectTab'
import CourseClassTeacherTab from './tabs/CourseClassTeacherTab'
import CourseClassTimetableTab from './tabs/CourseClassTimetableTab'
import CourseClassStudentTab from './tabs/CourseClassStudentTab'

export const courseClassRouteEntities = [
    {
        path: 'information',
        component: CourseClassInformationTab,
        breadcrumbName: (t) => t('information'),
    },
    {
        path: 'news',
        component: CourseClassNewsTab,
        breadcrumbName: (t) => t('news'),
        isInvisible: (props) => !!props?.item?.warnings,
    },
    {
        path: 'subjects',
        component: CourseClassSubjectTab,
        breadcrumbName: (t) => t('subjects'),
        isInvisible: (props) => !!props?.item?.warnings,
    },
    {
        path: 'teachers',
        component: CourseClassTeacherTab,
        breadcrumbName: (t) => t('teachers'),
        isInvisible: (props) => !!props?.item?.warnings,
    },
    {
        path: 'students',
        component: CourseClassStudentTab,
        breadcrumbName: (t) => t('students'),
    },
    {
        path: 'timetables',
        component: CourseClassTimetableTab,
        breadcrumbName: (t) => t('timetables'),
    },
    {
        icon: <BsPersonBoundingBox/>,
        path: 'attendances',
        component: CourseClassAttendanceTab,
        breadcrumbName: (t) => t('attendances'),
    },
    {
        icon: <RiAB/>,
        path: 'grades',
        component: CourseClassGradeTab,
        breadcrumbName: (t) => t('tests / grades'),
    },
]
